import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-submission-details-changes',
  templateUrl: './submission-details-changes.component.html',
  styleUrls: ['./submission-details-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmissionDetailsChangesComponent {
  @Input() changes!: KeyValue<string, string>[];
  @Input() label: string = '';
  @Input() borderColour: string = '';
  @Input() backgroundColour: string = '';
}
